module.exports = __webpack_public_path__ + "static/img/rule.d7b19ee.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/rule.png
// module id = 2nT+
// module chunks = 1